import React, { Component, Fragment } from 'react';
import classnames from 'classnames';

export default function MenuItem (props) {
  const { item, disabled, onSelect } = props;

  function handleSelect () {
    if (disabled) {
      return;
    }
    onSelect(item);
  }

  return (
    <div className={classnames('mce-menu-item mce-menu-item-normal mce-stack-layout-item', { disabled })} role="menuitem" onClick={handleSelect}>
      <span className="mce-text">{item.label}</span>
    </div>
  );
}
